// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Material
import { MatIconModule } from '@angular/material/icon';

// Local library
import { HeldService, IWithdrawalReview } from '@amwager/funding/data-access';
import { TranslatePipe, UnsubscribeObservableService } from '@amwager/util';

// Third party
import { takeUntil } from 'rxjs';

@Component({
  selector: 'feature-mat-held-withdrawals',
  templateUrl: './held.component.html',
  styleUrls: ['./held.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    TranslatePipe,
  ],
  standalone: true,
  providers: [HeldService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeldComponent extends UnsubscribeObservableService implements OnInit {

  reviews: IWithdrawalReview[] = [];
  isLoading = true;
  hasError = false;

  // Placeholder rows rendered by the loading skeleton.
  readonly skeletonRows = [1, 2, 3];

  isOnline = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly heldService: HeldService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.checkConnectivity();
    this.loadReviews();
  }

  loadReviews(): void {
    if (!this.isOnline) {
      this.heldService.setOffline('HeldComponent:loadReviews');
      return;
    }

    this.isLoading = true;
    this.hasError = false;

    this.heldService.loadReviews$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({ response, isSuccess }) => {
        if (isSuccess) {
          this.reviews = response ?? [];
          this.isLoading = false;
          this.hasError = false;
        } else if (isSuccess === false) {
          this.reviews = [];
          this.hasError = true;
          this.isLoading = false;
        }

        this.cdRef.markForCheck();
      });
  }

  cardLabel(review: IWithdrawalReview): string {
    return this.heldService.cardLabel(review);
  }

  brandIcon(review: IWithdrawalReview): string {
    return this.heldService.brandIcon(review);
  }

  statusLabel(review: IWithdrawalReview): string {
    return this.heldService.statusLabel(review);
  }

  statusKey(review: IWithdrawalReview): string {
    return this.heldService.statusKey(review);
  }

  statusColor(review: IWithdrawalReview): string {
    return this.heldService.statusColor(review);
  }

  requestedTime(review: IWithdrawalReview): string {
    return this.heldService.requestedTime(review);
  }

  checkConnectivity(): void {
    this.heldService.checkConnectivity(
      'HeldComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
